export default __webpack_public_path__ + "content/media/7.92a2bcf0.jpg";